var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('core-drawer'),_c('core-view'),_c('vue-progress-bar'),_c('notifications',{attrs:{"classes":"notification-custom","group":"notification","position":"bottom center","width":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }